import React from 'react'
import { useWatch as useHookWatch } from 'react-hook-form'
import PropTypes from 'prop-types'

/**
 * @author Miika Rantakaulio
 * @returns Object with subscribed fields and their values
 */
const WatchField = (props) => {
  const { fields, disabled = false, control, children } = props

  // if (!props.control) {
  //   throw new Error(
  //     'Field error: The required prop `control` was not provided to a '
  //     + `WatchField watching fields \`${fields}\`.`
  //   )
  // }

  const values = useHookWatch({ name: fields, disabled, control })
  if (!fields)
    throw new Error(
      'WatchField error: Must provide at least one field to watch'
    )
  const fieldValues = generateFieldValues(fields, values)

  return (
    <React.Fragment>
      {typeof children === 'function' ? children(fieldValues) : children}
    </React.Fragment>
  )
}

WatchField.propTypes = {
  control: PropTypes.object.isRequired,
  /** Names of fields to watch */
  fields: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.arrayOf(PropTypes.string).isRequired
  ]),
  /**
   * Option to disable subscription
   */
  disabled: PropTypes.bool
}

export default WatchField

export const useWatch = ({ fields, control, disabled = false }) => {
  const values = useHookWatch({ name: fields, disabled, control })
  const fieldValues = generateFieldValues(fields, values)
  return fieldValues
}

const generateFieldValues = (fields, values) =>
  typeof fields === 'string'
    ? { [fields]: values }
    : fields.reduce(
        (obj, key, index) => ({
          ...obj,
          [key]: values[index]
        }),
        {}
      )
